export interface UsuarioResponse {
    UsuarioID: number,
    NomeCompleto: string,
    NomeExibicao: string,
    UsuarioAcesso: string,
    DataNascimento: Date,
    TelefoneCelular: string,
    TelefoneFixo: string,
    Email: string,
    Token: string,
    TokenAES?: string,
    EmpresaID: number
    ImagemUrl: string
    ChavePix: string,
    CPF: string;
    TokenPushNotification: string;
    ManterConectado: boolean
    FrontOptions?: FrontOptions
    RefreshToken?: string
    ExpiresIn?: string
}

export interface FrontOptions {
    IgnoreHeader?: boolean;
    IgnoreSideBar?: boolean;
}

export enum FrontOptionsEnum {
    // eslint-disable-next-line no-unused-vars
    IgnoreHeader = "IgnoreHeader",
    // eslint-disable-next-line no-unused-vars
    IgnoreSideBar = "IgnoreSideBar",
}

